import React, { MouseEventHandler, FC } from 'react';
import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';
import { Button } from '@vimeo/iris/components';
import { themes } from '@vimeo/iris/themes';
import { Paragraph } from '@vimeo/iris/typography';

import { getDomain } from '../../utils/helpers';
import ShowcaseShareButton from '../ShowcaseShareButton';
import UpgradeBanner from '../UpgradeBanner';
import {
  ActionsSection,
  BottomSection,
  CreatorActionBarStyled,
  NavSection,
} from './CreatorActionBarStyled';

interface Props {
  albumId: number;
  albumPrivacy: string;
  canCreateEmbeddedPlaylists: boolean;
  embed: null | { html: string | null };
  hasVideos: boolean;
  isPreviewing: boolean;
  openShare: MouseEventHandler;
  isOffsite: boolean;
}

const noop: VoidFunction = () => undefined;

/**
 * Action bar that appears to creators to allow editing + sharing of album
 */
const CreatorActionBar: FC<Props> = ({
  albumId,
  canCreateEmbeddedPlaylists = false,
  embed,
  isPreviewing = false,
  hasVideos = false,
  openShare = noop,
  isOffsite = false,
}) => (
  <CreatorActionBarStyled>
    {isPreviewing && (
      <UpgradeBanner
        text={translate(
          'This is a preview of your custom album. To save and share your settings, upgrade to Pro.',
        )}
        linkText={translate('Upgrade')}
      />
    )}
    <BottomSection>
      <NavSection>
        {hasVideos && !isPreviewing && (
          <Paragraph size="2" theme={themes.dark} style={{ margin: 0 }}>
            {translate('This is what your showcase looks like when you share it')}
          </Paragraph>
        )}
      </NavSection>

      <ActionsSection>
        <Link href={`${getDomain(isOffsite)}/manage/showcases/${albumId}`}>
          <Button element="span" format="secondary">
            {translate('Edit')}
          </Button>
        </Link>
        <ShowcaseShareButton
          canCreateEmbeddedPlaylists={canCreateEmbeddedPlaylists}
          embed={embed}
          openShare={openShare}
        />
      </ActionsSection>
    </BottomSection>
  </CreatorActionBarStyled>
);

export default CreatorActionBar;

const Link = styled.a`
  text-decoration: none;
`;
